<div class="side-menu">
  <div class="side-menu-content">
    @if (campaign && campaign.campaignBrandStatus !== "draft") {
      <div class="title">
        {{ "brand.campaign.navigation.summarySection" | translate }}
      </div>
      <ul class="menu-list">
        @if (isShown(NavigationItems.Dashboard)) {
          <li class="menu-item" [routerLinkActive]="'is-active'">
            <a
              data-test="nav-dashboard"
              class="menu-item-anchor"
              [routerLink]="['dashboard']"
              [ngClass]="{ disabled: !campaign }"
            >
              <img
                class="default"
                *ngIf="'is-active'"
                src="/assets/images/icons/ic_dashboard.svg"
              />
              <img
                class="active"
                *ngIf="'!is-active'"
                src="/assets/images/icons/ic_dashboard_hover.svg"
              />
              <span>{{
                "brand.campaign.navigation.dashboard" | translate
              }}</span
              >&nbsp;
            </a>
          </li>
        }
        @if (isShown(NavigationItems.Partners)) {
          <li class="menu-item" [routerLinkActive]="'is-active'">
            <a
              data-test="nav-partners"
              class="menu-item-anchor"
              [routerLink]="['partners']"
              [ngClass]="{ disabled: !campaign }"
            >
              <img
                class="default"
                *ngIf="'is-active'"
                src="/assets/images/icons/ic_partners.svg"
              />
              <img
                class="active"
                *ngIf="'!is-active'"
                src="/assets/images/icons/ic_partners_hover.svg"
              />
              <span>{{ "brand.campaign.navigation.partners" | translate }}</span
              >&nbsp;
            </a>
          </li>
        }
        @if (isShown(NavigationItems.PostsCalendar)) {
          <li class="menu-item" [routerLinkActive]="'is-active'">
            <a
              data-test="nav-posts-calendar"
              class="menu-item-anchor"
              [routerLink]="['posts-calendar']"
            >
              <img
                class="default"
                *ngIf="'is-active'"
                src="/assets/images/icons/ic_editCalendar.svg"
              />
              <img
                class="active"
                *ngIf="'!is-active'"
                src="/assets/images/icons/ic_editCalendar_hover.svg"
              />

              <span>{{ "brand.campaign.navigation.calendar" | translate }}</span
              >&nbsp;
            </a>
          </li>
        }
        @if (isShown(NavigationItems.PostedScheduled)) {
          <li class="menu-item" [routerLinkActive]="'is-active'">
            <a
              data-test="nav-posts"
              class="menu-item-anchor"
              [routerLink]="['posts']"
              [ngClass]="{ disabled: !campaign }"
            >
              <img
                class="default"
                *ngIf="'is-active'"
                src="/assets/images/icons/ic_posted_stories.svg"
              />
              <img
                class="active"
                *ngIf="'!is-active'"
                src="/assets/images/icons/ic_posted_stories_hover.svg"
              />
              <span>{{
                "brand.campaign.navigation.postedStories" | translate
              }}</span
              >&nbsp;
            </a>
          </li>
        }
        @if (isShown(NavigationItems.Map)) {
          <li class="menu-item" [routerLinkActive]="'is-active'">
            <a
              data-test="nav-map"
              class="menu-item-anchor"
              [routerLink]="['map']"
              [ngClass]="{ disabled: !campaign }"
            >
              <img
                class="default"
                *ngIf="'is-active'"
                src="/assets/images/icons/ic_map.svg"
              />
              <img
                class="active"
                *ngIf="'!is-active'"
                src="/assets/images/icons/ic_map_hover.svg"
              />
              <span>{{ "brand.campaign.navigation.map" | translate }}</span
              >&nbsp;
            </a>
          </li>
        }
      </ul>
    }
    <div class="title">
      {{ "brand.campaign.navigation.campaignDetails" | translate }}
    </div>
    <ul class="menu-list">
      @if (
        isShown(NavigationItems.InformationSettings) ||
        isShown(NavigationItems.InformationDetails) ||
        isShown(NavigationItems.InformationInvitePage)
      ) {
        <li class="menu-item" [routerLinkActive]="'is-active'">
          <div>
            <a
              data-test="nav-campaign-details"
              class="menu-item-anchor"
              [routerLink]="['information']"
            >
              <img
                class="default"
                *ngIf="'is-active'"
                src="/assets/images/icons/ic_editDetails.svg"
              />
              <img
                class="active"
                *ngIf="'!is-active'"
                src="/assets/images/icons/ic_editDetails_hover.svg"
              />
              <span>{{ "brand.campaign.navigation.details" | translate }}</span>
            </a>
            @if (isViewingInfoPage) {
              <div>
                @if (isShown(NavigationItems.InformationSettings)) {
                  <a
                    data-test="nav-campaign-settings"
                    class="menu-item-sub-anchor"
                    [routerLink]="['information/settings']"
                    [routerLinkActive]="'menu-item-sub-anchor--active'"
                  >
                    <span>{{
                      "brand.campaign.navigation.campaignSettings" | translate
                    }}</span>
                  </a>
                }
                @if (isShown(NavigationItems.InformationDetails)) {
                  <a
                    data-test="nav-campaign-info"
                    class="menu-item-sub-anchor"
                    [routerLink]="['information/details']"
                    [routerLinkActive]="'menu-item-sub-anchor--active'"
                  >
                    <span>{{
                      "brand.campaign.navigation.campaignInformation"
                        | translate
                    }}</span>
                  </a>
                }
                @if (isShown(NavigationItems.InformationInvitePage)) {
                  <a
                    data-test="nav-invite-page"
                    class="menu-item-sub-anchor"
                    [routerLink]="'information/invite-page'"
                    [routerLinkActive]="'menu-item-sub-anchor--active'"
                  >
                    <span>{{
                      "brand.campaign.navigation.invitePage" | translate
                    }}</span>
                  </a>
                }
              </div>
            }
          </div>
        </li>
      }
      @if (isShown(NavigationItems.Content)) {
        <li
          class="menu-item"
          [routerLinkActive]="'is-active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <a
            data-test="nav-content"
            class="menu-item-anchor"
            [routerLink]="['content']"
          >
            <img
              class="default"
              *ngIf="'is-active'"
              src="/assets/images/icons/ic_editContent.svg"
            />
            <img
              class="active"
              *ngIf="'!is-active'"
              src="/assets/images/icons/ic_editContent_hover.svg"
            />
            <span>{{
              "brand.campaign.navigation.content" | translate
            }}</span></a
          >
        </li>
      }
      @if (isShown(NavigationItems.Publications)) {
        <li
          class="menu-item"
          [routerLinkActive]="'is-active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <a
            data-test="nav-publication-templates"
            class="menu-item-anchor"
            [routerLink]="[
              BrandUrl.Campaign.Publications(brandId, campaign?.id)
            ]"
          >
            <img
              class="default"
              *ngIf="'is-active'"
              src="/assets/images/icons/ic_editContent.svg"
            />
            <img
              class="active"
              *ngIf="'!is-active'"
              src="/assets/images/icons/ic_editContent_hover.svg"
            />
            <span>{{
              "brand.campaign.navigation.publicationTemplates" | translate
            }}</span>
          </a>
        </li>
      }
      @if (isShown(NavigationItems.PromotedAds)) {
        <li class="menu-item" [routerLinkActive]="'is-active'">
          <a
            data-test="nav-promoted-ads"
            class="menu-item-anchor"
            [routerLink]="['promoted-ads']"
          >
            <img
              class="default"
              *ngIf="'is-active'"
              src="/assets/images/icons/ic_editPromoAds.svg"
            />
            <img
              class="active"
              *ngIf="'!is-active'"
              src="/assets/images/icons/ic_editPromoAds_hover.svg"
            />
            <span>{{ "brand.campaign.navigation.promoAds" | translate }}</span>
          </a>
          @if (isViewingPromotedAdsPage) {
            <a
              data-test="nav-ads-settings"
              class="menu-item-sub-anchor"
              (click)="goToPromoAds(BrandCampaignPromoAdsPage.Settings)"
              [ngClass]="{
                'menu-item-sub-anchor--active':
                  promoAdsPage === BrandCampaignPromoAdsPage.Settings
              }"
            >
              <span>{{
                "brand.campaign.navigation.promoAdsGeneralSettings" | translate
              }}</span>
            </a>
          }
          @if (isViewingPromotedAdsPage) {
            <a
              data-test="nav-ads-marketing"
              (click)="
                goToPromoAds(BrandCampaignPromoAdsPage.MarketingChannels)
              "
              class="menu-item-sub-anchor"
              [ngClass]="{
                'menu-item-sub-anchor--active':
                  promoAdsPage === BrandCampaignPromoAdsPage.MarketingChannels
              }"
            >
              <span>
                {{
                  "brand.campaign.navigation.promoAdsSocialMediaSettings"
                    | translate
                }}
              </span>
            </a>
          }
        </li>
      }
      @if (isShown(NavigationItems.LandingPage)) {
        <li
          *ngIf="showLandingPage"
          class="menu-item"
          [routerLinkActive]="'is-active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <a
            data-test="nav-landing-page"
            class="menu-item-anchor"
            [routerLink]="['landing-page']"
          >
            <img
              class="default"
              *ngIf="'is-active'"
              src="/assets/images/web-builder.svg"
            />
            <img
              class="active"
              *ngIf="'!is-active'"
              src="/assets/images/web-builder-hover.svg"
            />
            <span>{{
              "brand.campaign.navigation.landingPage" | translate
            }}</span></a
          >
        </li>
      }
      @if (isShown(NavigationItems.ContentCalendar)) {
        <li class="menu-item" [routerLinkActive]="'is-active'">
          <a
            data-test="nav-content-calendar"
            class="menu-item-anchor"
            [routerLink]="['content-calendar']"
          >
            <img
              class="default"
              *ngIf="'is-active'"
              src="/assets/images/icons/ic_editCalendar.svg"
            />
            <img
              class="active"
              *ngIf="'!is-active'"
              src="/assets/images/icons/ic_editCalendar_hover.svg"
            />
            <span>
              {{ "brand.campaign.navigation.contentCalendar" | translate }}
            </span>
          </a>
        </li>
      }
      @if (isShown(NavigationItems.InvitePartners)) {
        @if (!isProspectPartnersEnabled) {
          <li class="menu-item" [routerLinkActive]="'is-active'">
            <a
              data-test="nav-invite-partners"
              class="menu-item-anchor"
              [routerLink]="['invite-partners']"
            >
              <img
                class="default"
                *ngIf="'is-active'"
                src="/assets/images/icons/ic_partner_new.svg"
              />
              <img
                class="active"
                *ngIf="'!is-active'"
                src="/assets/images/icons/ic_partner_new_hover.svg"
              />
              <span>
                {{ "brand.campaign.navigation.invitePartners" | translate }}
              </span>
            </a>
          </li>
        }
        @if (isProspectPartnersEnabled) {
          <li
            class="menu-item"
            [routerLinkActive]="'is-active'"
            (isActiveChange)="partnersTabChanged($event)"
          >
            <a
              data-test="nav-invite-partners"
              class="menu-item-anchor"
              [routerLink]="['invite-partners']"
            >
              <img
                class="default"
                *ngIf="'is-active'"
                src="/assets/images/icons/ic_partner_new.svg"
              />
              <img
                class="active"
                *ngIf="'!is-active'"
                src="/assets/images/icons/ic_partner_new_hover.svg"
              />
              <span>
                {{ "brand.campaign.navigation.invitePartners" | translate }}
              </span>
              @if (partnersSheetProcessingProgress !== undefined) {
                <div class="notifications">
                  @if (partnersSheetProcessingProgress < 100) {
                    <div class="mat-progress-spinner--with-back-circle">
                      <mat-progress-spinner
                        [ngClass]="{
                          'mat-progress-spinner--white':
                            isPartnersSectionSelected,
                          'mat-progress-spinner--text-color':
                            !isPartnersSectionSelected
                        }"
                        [diameter]="16"
                        mode="determinate"
                        [value]="partnersSheetProcessingProgress"
                      />
                    </div>
                  }
                  @if (partnersSheetProcessingProgress === 100) {
                    <mat-icon>check_circle</mat-icon>
                  }
                </div>
              }
            </a>
          </li>
        }
      }
      @if (showPOS && isShown(NavigationItems.Content)) {
        <li class="menu-item" [routerLinkActive]="'is-active'">
          <a
            data-test="nav-pos"
            class="menu-item-anchor"
            [routerLink]="['pos']"
          >
            <img
              class="default"
              *ngIf="'is-active'"
              src="/assets/images/icons/ic_editPOS.svg"
            />
            <img
              class="active"
              *ngIf="'!is-active'"
              src="/assets/images/icons/ic_editPOS_hover.svg"
            />
            <span>{{ "shared.POS" | translate }}</span></a
          >
        </li>
      }
      @if (isShown(NavigationItems.Summary)) {
        <li class="menu-item" [routerLinkActive]="'is-active'">
          <a
            data-test="nav-campaign-summary"
            class="menu-item-anchor"
            [routerLink]="['summary']"
          >
            <img
              class="default"
              *ngIf="'is-active'"
              src="/assets/images/icons/ic_summary.svg"
            />
            <img
              class="active"
              *ngIf="'!is-active'"
              src="/assets/images/icons/ic_summary_hover.svg"
            />
            <span>{{ "brand.campaign.navigation.summary" | translate }}</span>
          </a>
        </li>
      }
    </ul>
  </div>
</div>
<div class="content">
  <div class="right-header">
    @if (campaign) {
      <app-brand-campaign-header
        [title]="campaign.name"
        [campaignType]="campaign.type"
      />
    }
  </div>
  <div class="main">
    <router-outlet />
  </div>
</div>
